import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";

import { NewsPaperVendorData } from "../../../FetchAPI";
import { useAuth } from "../../../../Store/AuthContext";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../../DeshBoardFooter";
import Sidebar from "../../Sidebar";
import NotifyMessageNoReload from "../../../Others/NotifyMessageNoReload";
import { Helmet } from "react-helmet";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function NewsScheduleUpdate() {
  let { newsid } = useParams();

  const { userID, RendomTokenfetch } = useAuth();

  const [NewsVendorData] = NewsPaperVendorData(RendomTokenfetch, newsid);
  // console.log(NewsVendorData);
  const navigate = useNavigate();

  // const [error, setError] = useState({});
  const newsvendorstatus = [
    { id: "1", title: "Publish" },
    { id: "0", title: "UnPublish" },
  ];

  // console.log(newsvendorstatus);
  // Refs for all inputs
  const datenew = useRef(NewsVendorData?.date_newformate || "");
  const fileInputRef = useRef(null);
  const [vendorstatus, setvendorstatus] = useState("0");
  // const vendorstatus = useRef(NewsVendorData?.vender_status || "");

  useEffect(() => {
    if (NewsVendorData?.status_new !== undefined) {
      setvendorstatus(String(NewsVendorData.status_new));
    }
  }, [NewsVendorData]);

  // Handle On Form Submit
  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("news_id", newsid);
    fdata.append("status_new", vendorstatus);
    fdata.append("date_new", datenew.current.value);
    if (fileInputRef.current.files[0]) {
      fdata.append("file", fileInputRef.current.files[0]);
    }

    axios
      .post(`${WebsiteAPIurl}newspeparschedule`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (vendorstatus) {
          if (response.data.Status === "0") {
            NotifyMessageNoReload(response.data.message, "danger", true);
            // setError(ProfileEditValidation(response.data.form_validation));
          }
          if (response.data.Status === "1") {
            NotifyMessageNoReload(response.data.message, "success", true);
            navigate(`/news-paper-schedule`);
          }
        } else {
          // console.log(response.data);
          // setError(ProfileEditValidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "News Paper Schedule", pagelink: "news-paper-schedule" },
            { name: "schedule-update" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content py-4">
                      <form
                        className="was-validated"
                        onSubmit={handleSubmit}
                        encType="multipart/form-data"
                      >
                        <div className="row">
                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="Date">
                              Date <span className="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="datenew"
                              ref={datenew}
                              defaultValue={
                                NewsVendorData?.date_newformate || ""
                              }
                              required
                            />
                          </div>

                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>
                              Vendor Work Status{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={vendorstatus}
                              onChange={(e) => setvendorstatus(e.target.value)}
                              required
                            >
                              {newsvendorstatus &&
                                newsvendorstatus.map((valStatus) => (
                                  <option
                                    value={valStatus.id}
                                    key={valStatus.id}
                                  >
                                    {valStatus.title}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="Date">
                              PDF Upload <span className="text-danger">*</span>
                            </label>
                            <div
                              className="input-group"
                              style={{ marginTop: "4px" }}
                            >
                              <input
                                type="file"
                                className="form-control"
                                ref={fileInputRef}
                              />
                              {NewsVendorData.pdf_update && (
                                <Link
                                  to={`${NewsVendorData.pdf_update}`}
                                  data-fancybox
                                  data-caption="pdf"
                                  className="pdfDownloadedBTN"
                                >
                                  <i
                                    className="fa fa-download"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              )}
                            </div>
                          </div>

                          <div className="form-group col-lg-12 col-md-12 text-center mt-3">
                            <button
                              className="AllsiteButton mt-2"
                              type="submit"
                              name="submit"
                            >
                              SUBMIT
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
